module.exports = __webpack_public_path__ + "static/media/handschuhe_falsch_active.8e74a9df.jpg";